<script>
    export let inquiry
    export let field

    let confirmed = false

    function update(p) {
        return () => {
            const array = []
            for (let i = 0; i < processing.length; i++) {
                const element = processing[i]
                if(element.id === p.id) {
                    array[i] = {...element, active: !element.active}
                } else {
                    array[i] = element;
                }
            }
            processing = array
        }
    }

    function extract(inquiry) {
        return field.processing.map( (it, idx) =>  {  
            return { ...it, id: idx, active: true }
        })
    }

    function confirm(to) {
        return () => {
            confirmed = to
        }
    }

    $: processing = extract(inquiry)
    $: remove = processing.every(it => !it.active)
    $: status = remove ? "removido" : "mantido"

</script>
<style>
    .spread {
        display: flex;
        align-items: baseline;
    }

    .spread .fill {
        flex: 1;
    }

    .ddr.segments {
        background: #fff;
    }

    .remove label {
        text-decoration: line-through;
    }

    .confirmed .fields, .confirmed .actions {
        display: none;
    }

    .status {
        display: none;
        cursor: pointer;
    }

    .confirmed .status {
        display: block;
    }
</style>
<div class="ui ddr segments" class:confirmed>
    <div class="ui spread segment">
        <div><h4>{field.name}</h4></div>
        <div class="fill"></div>
        <div class="status">
            <!-- <i class="toggle on icon" class:green={!remove}></i> -->
            <div class="ui tiny label" class:green={!remove} on:click={confirm(false)}>
                {status}
            </div>
        </div>
    </div>
    <div class="ui fields segments">
        {#each processing as p}
            <div class="ui segment spread" class:remove={!p.active}>
                <div class="ui toggle big checkbox">
                    <input type="checkbox" checked={p.active} on:change={update(p)}>
                    <label>{p.purpose}</label>
                </div>
                <div class="fill"></div>
                <div class="ui tiny label" class:green={p.active}>{p.basis}</div>
            </div>
        {/each}
    </div>
    <div class="ui actions secondary spread segment">
        {#if remove}
            <p>O campo será removido</p>
        {:else}
            <p>O campo será mantido</p>
        {/if}
        <div class="fill"></div>           
        <button class="ui small button" on:click={confirm(true)}>Confirmar</button>
    </div>
</div>